import { Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";

const HeatExchangerEha = ({ styles, techData, heatRecovery, type }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <View style={{ ...styles["section-wrapper"], marginTop: "5px" }}>
      <View style={styles.heading}>
        <View style={styles["heading-flex"]}>
          <Text
            style={{
              ...styles.title,
              width: "5%",
              borderRight: "2px solid white",
            }}
          >
            {heatRecovery === "Rotary heat exchanger" ? "RC" : "PC"}
          </Text>
          <View style={styles["inner-flex"]}>
            <Text style={styles.title}>
              {type === "exhaust"
                ? t("techCard.Ecodesign.Exhaust").toUpperCase()
                : t("techCard.Ecodesign.Supply").toUpperCase()}{" "}
              {heatRecovery === "Rotary heat exchanger"
                ? t("techCard.RotaryHeat").toUpperCase()
                : t("techCard.PlateHeat").toUpperCase()}
            </Text>
            <View style={styles["inner-inner"]}>
              <Text style={styles.title}>
                {t("techCard.PressureDrop")} [Pa]:
              </Text>
              <Text style={styles.title}>{techData.rec_Eha_PressureDrop}</Text>
            </View>
          </View>
        </View>
      </View>
      <Text style={styles["sm-pad"]}>
        {heatRecovery === "Rotary heat exchanger"
          ? t("techCard.RotaryHeat").toUpperCase()
          : t("techCard.PlateHeat").toUpperCase()}
      </Text>
      <Text style={styles["sm-pad"]}>{techData.calculation.rec_Model}</Text>
      <View style={styles.flex}>
        <View style={{ ...styles.left, paddingRight: "5px" }}>
          <View style={styles["md-flex"]}>
            <Text style={{ ...styles.label, color: "red" }}>
              {t("techCard.HeatExcSec.HeatingMode")}:
            </Text>
            <Text></Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.StanAirVol")} m³/h:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.eha_AirVolumeFlow}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.FaceAirVelo")} m/s:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.eha_AirVelocity}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.HeatExcSec.InletTemp")} °C /{" "}
              {t("techCard.HeatExcSec.RelativeHum")} %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.eha_AirTempIn} /{" "}
              {techData.calculation.winterRecCalculation.eha_HumidityIn}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.HeatExcSec.OutletTemp")} °C /{" "}
              {t("techCard.HeatExcSec.RelativeHum")} %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.eha_AirTempOut} /{" "}
              {techData.calculation.winterRecCalculation.eha_HumidityOut}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.PressureDrop")} (
              {t("techCard.HeatExcSec.ActualDens")}) Pa:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.eha_AirPressureDrop}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.PressureDrop")} (
              {t("techCard.HeatExcSec.StandardDens")}) Pa:
            </Text>
            <Text style={styles.value}>
              {
                techData.calculation.winterRecCalculation
                  .eha_ExternalPDStandardDensity
              }
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.Condensate")} [l/h]
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.eha_Condensate}
            </Text>
          </View>

          <View style={styles["md-flex"]}>
            <Text style={styles.label}>OACF</Text>
            <Text style={styles.value}>
              {" "}
              {techData.calculation.summerRecCalculation.oacf}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>EATR</Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.eatr}
            </Text>
          </View>
        </View>
        <View style={styles.right}>
          <View style={styles["md-flex"]}>
            <Text style={{ ...styles.label, ...styles.cool }}>
              {t("techCard.HeatExcSec.CoolingMode")}:
            </Text>
            <Text></Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.StanAirVol")} m³/h:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.eha_AirVolumeFlow}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.FaceAirVelo")} m/s:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.eha_AirVelocity}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.HeatExcSec.InletTemp")} °C /{" "}
              {t("techCard.HeatExcSec.RelativeHum")} %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.eha_AirTempIn} /{" "}
              {techData.calculation.summerRecCalculation.eha_HumidityIn}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.HeatExcSec.OutletTemp")} °C /{" "}
              {t("techCard.HeatExcSec.RelativeHum")} %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.eha_AirTempOut} /{" "}
              {techData.calculation.summerRecCalculation.eha_HumidityOut}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.PressureDrop")} (
              {t("techCard.HeatExcSec.ActualDens")}) Pa:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.eha_AirPressureDrop}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.PressureDrop")} (
              {t("techCard.HeatExcSec.StandardDens")}) Pa:
            </Text>
            <Text style={styles.value}>
              {
                techData.calculation.summerRecCalculation
                  .eha_ExternalPDStandardDensity
              }
            </Text>
          </View>
        </View>
      </View>
      <View style={[styles.extras, styles.flex]}>
        <View style={{ ...styles.left, paddingRight: "5px" }}>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.PlateMat")}:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.rec_Material}
            </Text>
          </View>
          {heatRecovery === "Rotary heat exchanger" ? (
            <View style={styles["md-flex"]}>
              <Text style={styles.label}>
                {t("techCard.HeatExcSec.Controller")} Hz:
              </Text>
              <Text style={styles.value}>
                {techData.calculation.rec_Controller}
              </Text>
            </View>
          ) : (
            <></>
          )}
        </View>
        <View style={styles.right}></View>
      </View>

      {techData.calculation.rec_SpeedRegulator === "Yes" ? (
        <View style={styles.extras}>
          <Text>{t("techCard.HeatExcSec.WithSpeedRegulator")}</Text>
          <Text>{t("techCard.HeatExcSec.sorption")}</Text>
        </View>
      ) : null}
    </View>
  );
};

export default HeatExchangerEha;
